interface ButtonMenuProps {
    inputParam: any;
    ButtonData: Record<string, { key: string }[]>;
    visibleDivId: any;
    menuRef: React.RefObject<HTMLDivElement>;
    insertText: (text: string, category: string) => void;
  }
  
const DropdownMenu: React.FC<ButtonMenuProps> = ({
    inputParam,
    ButtonData,
    visibleDivId,
    menuRef,
    insertText,
  }) => {
    return (
      <div
        id={inputParam?.name}
        className={`w-64 card border rounded-lg shadow-lg p-2 z-50 flex flex-col absolute bg-white max-h-96 overflow-y-auto max-h-[calc(100vh-250px)] mt-8 ${
          visibleDivId === inputParam?.name ? 'block' : 'hidden'
        }`}
        ref={menuRef}
      >
        {Object.entries(ButtonData).map(([category, buttons]) => (
          <div key={category} className="mb-2">
            <label className="font-semibold text-sm mb-2 block">{category}</label>
            <div className="flex flex-col justify-start items-start">
              {buttons.map((button, index) => (
                <button
                  key={index}
                  onClick={() => insertText(button.key, category)}
                  className="px-4 py-2 hover:bg-gray-100 text-left w-full text-xs hover:rounded-md"
                >
                  <span className="bg-teal-100 rounded-sm px-1">{button.key}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };
  
export default DropdownMenu;
  